/* eslint-disable @next/next/no-img-element */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState } from 'react'
import Head from 'next/head'
import Link from 'next/link'
import PropTypes from 'prop-types'
import SharingComponent from '../../components/Sharing'
import Transcript from '../../components/Transcript'
import VideoAnalyzer from '../../components/VideoAnalyzer'
import Layout from '../../components/Layout'
import useFallback from '../../hooks/useFallback'

export default function Tool({ tool, tools }) {
  const fallback = useFallback()
  const [currentHeader, setCurrentHeader] = useState()

  if (fallback) {
    return fallback
  }

  const toolContent = (tool) => {
    switch (tool.slug.current) {
      case 'free-youtube-subtitles-downloader':
        return <Transcript />
      case 'free-youtube-video-analyzer':
        return <VideoAnalyzer />
    }

    return null
  }

  return (
    <main>
      <Head>
        <link
          rel="canonical"
          href={`https://www.tubetranscripts.com/tools/${tool.slug.current}`}
          key="canonical"
        />
        <meta name="description" content={tool.description} key="description" />

        <title key="title">{tool.title} | Tube Transcriptss</title>

        <meta
          property="og:title"
          content={`${tool.title} | Tube Transcripts`}
          key="og-title"
        />
        <meta
          property="og:description"
          content={tool.description}
          key="og-description"
        />
        <meta
          property="og:url"
          content={`https://www.tubetranscripts.com/tools/${tool.slug.current}`}
          key="og-url"
        />
      </Head>
      <div className="flex flex-col items-center justify-center w-full mt-12">
        <h1 className="w-full max-w-2xl px-8 mt-6 text-4xl font-extrabold text-center text-gray-800 font-body lg:text-5xl">
          {tool.title}
        </h1>
        <p className="w-full max-w-2xl px-8 mt-12 text-lg text-center text-gray-400 font-body">
          {tool.description} 👇
        </p>
        <div className="grid w-full grid-cols-12 px-2 mt-24">
          <div className="hidden col-span-3 pl-8 lg:block">
            <div className="sticky py-8 pl-24 pr-4 text-sm text-gray-400 top-2">
              <ol className="space-y-3 list-decimal list-outside decoration-gray-200">
                {(tool.headers || []).map((header, index) => {
                  return (
                    <li
                      key={`header-${index}`}
                      className={`${
                        currentHeader === index + 1 ? 'text-gray-800' : ''
                      } hover:text-gray-800`}>
                      <a
                        onClick={() => setCurrentHeader(index + 1)}
                        href={`#${index + 1}`}>
                        {header}
                      </a>
                    </li>
                  )
                })}
              </ol>
            </div>
          </div>
          <div className="flex flex-col max-w-3xl col-span-12 px-2 py-2 border border-gray-200 lg:col-span-6 rounded-2xl">
            {toolContent(tool)}
          </div>
          <div className="hidden col-span-3 px-4 text-sm lg:block">
            <p className="text-gray-500">All our free tools 👇</p>
            <ol className="mt-4 space-y-3 decoration-gray-200">
              {(tools || []).map((t, index) => {
                return (
                  <li
                    key={`tool-${index}`}
                    className={`${
                      tool.slug.current === t.slug.current
                        ? 'text-gray-800'
                        : 'text-gray-400'
                    } hover:text-gray-800`}>
                    <a href={t.slug.current}>{t.title}</a>
                  </li>
                )
              })}
            </ol>
          </div>
        </div>
        <div className="relative flex mt-4 mb-24 rounded-2xl">
          <Link href="/">
            <a className="flex items-center justify-center w-full px-4 py-2 text-base font-medium text-purple-500 underline border border-transparent rounded-full hover:text-white hover:bg-purple-700 focus:ring-2 focus:ring-offset-2 focus:ring-purple-500">
              I want to Grow my channel
            </a>
          </Link>
        </div>
        <div className="w-11/12 max-w-3xl mt-8 lg:px-0">
          <SharingComponent
            url={`https://www.tubetranscripts.com/tools/${tool.slug.current}`}
            title={tool.title}
          />
        </div>
      </div>
    </main>
  )
}

const tools = [
  {
    title: 'Free YouTube Video Analyzer',
    description:
      'Analyze the description, thumbnail, keywords and more of any public YouTube video for free',
    slug: {
      current: 'free-youtube-video-analyzer',
    },
  },
  // {
  //   title: 'Free YouTube Thumbnail Downloader',
  // eslint-disable-next-line max-len
  //   description: 'Download the thumbnails of any public YouTube video for free',
  //   slug: {
  //     current: 'free-youtube-thumbnail-downloader',
  //   },
  // },
  {
    title: 'Free YouTube Subtitles Downloader',
    description: 'Download the subtitles of any public YouTube video for free',
    slug: {
      current: 'free-youtube-subtitles-downloader',
    },
  },
  // {
  //   title: 'Free YouTube Niche Reports',
  //   description:
  //     'Explore reports on currently trending niches on YouTube for free.',
  //   slug: {
  //     current: 'free-youtube-niche-reports',
  //   },
  // },
]

export async function getStaticProps(context) {
  const {
    params: { slug },
  } = context

  const tool = tools.find((t) => t.slug.current === slug)

  return {
    props: {
      tools,
      tool,
    },
    revalidate: 600,
  }
}

export async function getStaticPaths() {
  const paths = tools.map((a) => {
    return {
      params: { slug: a.slug.current },
    }
  })

  return {
    paths: paths,
    fallback: true,
  }
}

Tool.getLayout = function getLayout(page) {
  return <Layout>{page}</Layout>
}

Tool.propTypes = {
  tool: PropTypes.object.isRequired,
  tools: PropTypes.array,
}
